import React from 'react';

function safeHTMLLink(m) {
	let a = document.createElement('div');

	a.innerHTML = m;

	let t = getStringsFromChildren(a);

	return t;
}

function getStringsFromChildren(parentNode) {
	var strings = [],
		nodeList,
		length;

	if ((!parentNode) instanceof Node) {
		throw new TypeError(
			'The parentNode parameter expects an instance of a Node.'
		);
	}

	if (!parentNode.hasChildNodes()) {
		return null; // We are done. Node may resemble <element></element>
	}

	nodeList = parentNode.childNodes;
	length = nodeList.length;

	for (var i = 0; i < length; i++) {
		let nod = nodeList[i];

		if (nod.nodeType === Node.TEXT_NODE) {
			strings.push(nod.nodeValue);
		}

		if (
			nod.nodeType === Node.ELEMENT_NODE &&
			nod.tagName.toLowerCase() === 'a'
		) {
			let noch = nod.childNodes[0];

			let input;

			if (noch.nodeType === Node.TEXT_NODE) {
				input = noch.nodeValue.replace(/&/g, '&amp;');
				input = input.replace(/</g, '&lt;');
				input = input.replace(/>/g, '&gt;');
			} else if (
				noch.nodeType === Node.ELEMENT_NODE &&
				noch.tagName.toLowerCase() === 'img'
			) {
				let src = noch.src.replace(/&/g, '&amp;');
				src = src.replace(/</g, '&lt;');
				src = src.replace(/>/g, '&gt;');

				input = <img src={src} />;
			}

			if (input) {
				strings.push(
					<a key={i} href={nod.href}>
						{input}
					</a>
				);
			}
		}
	}

	if (strings.length > 0) {
		return strings;
	}

	return null;
}

export default (w) => {
	for (var i = 0; i < w.news.length; i++) {
		let n = w.news[i];

		if (n.m.m && !Array.isArray(w.news[i].m.m)) {
			w.news[i].m.m = safeHTMLLink(n.m.m);
		}

		for (var ii = 0; ii < n.c.length; ii++) {
			let c = n.c[ii];

			if (c.m.m && !Array.isArray(w.news[i].c[ii].m.m)) {
				w.news[i].c[ii].m.m = safeHTMLLink(c.m.m);
			}
		}
	}

	return w;
};
